import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to CDN
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://cdn.magicpatterns.com';
document.head.appendChild(preconnectCDN);
// Preload critical LCP image
const preload = document.createElement('link');
preload.rel = 'preload';
preload.as = 'image';
preload.href = 'https://cdn.magicpatterns.com/uploads/wcXtcMFSsFBjWMygCq2htT/mockup_sevillanas_webp.webp';
preload.type = 'image/webp';
preload.fetchPriority = 'high';
document.head.appendChild(preload);
render(<App data-id="element-334" />, document.getElementById('root'));